import n, { useContext as r } from "react";
import { b as s } from "./ConversationStateProvider2.js";
import "./jsx-runtime.js";
import "./utils.js";
const u = (t) => t;
function i(t, e = u) {
  const o = n.useSyncExternalStore(
    t.subscribe,
    () => e(t.getState()),
    () => e(t.getInitialState())
  );
  return n.useDebugValue(o), o;
}
function f() {
  const t = r(s);
  return i(t);
}
export {
  f as useConversationStateContext
};
